import { render, staticRenderFns } from "./ProjectAdCampaignEdit.vue?vue&type=template&id=8f328004"
import script from "./ProjectAdCampaignEdit.vue?vue&type=script&lang=js"
export * from "./ProjectAdCampaignEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports